import React from 'react'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { InputLabel } from '@mui/material'
import TextField from '@mui/material/TextField'
import CalenderIcon from 'assets/icons/calender'
// import { de } from 'date-fns/locale'
import 'moment/locale/de';
import moment from 'moment';

const normalizeToMoment = (val) => {
  if (!val) return null

  // Already a moment object
  if (moment.isMoment(val)) return val

  // Native Date
  if (val instanceof Date) return moment(val)

  // ISO string (from DB)
  if (typeof val === "string") return moment(val)

  return null
}

const CustomDatePicker = ({
  label,
  containerClasses,
  labelClasses,
  value,
  handleChange,
  error,
  inputBackgroundColor = 'transparent',
  helperText,
  placeholder = 'Tag/Monat/Jahr',
  ...props
}) => {

  return (
    <div className={containerClasses}>
      <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="de">
        <InputLabel shrink htmlFor='date-input' className={labelClasses} >
          {label}
        </InputLabel>

        <DatePicker
          label={placeholder}
          value={normalizeToMoment(value)}
          components={{
            OpenPickerIcon: CalenderIcon,
          }}
          minDate={moment('01-01-1970')}
          // We need to use moment formatting
          format="L"
          onChange={(value, keyboardInputValue, ...props) =>
            handleChange(value, keyboardInputValue, ...props)
          }
          className='w-full'

          renderInput={(params) => {
            <TextField
              {...params}
              error={error}

              sx={{
                [`& .MuiInputBase-root`]: {
                  backgroundColor: inputBackgroundColor,
                  height: 45,
                },
              }}
              helperText={helperText} />
          }}
          {...props}
        />
      </LocalizationProvider>
    </div>
  )
}

export default CustomDatePicker
